// extracted by mini-css-extract-plugin
export default {"loading-screen":"LoadingScreen_loading-screen__2u3kg"};